import { parseGlobIcon } from '@utils/parse-glob-icon';

export const menus: {
  path: string;
  name: string;
  key: string;
  target?: string;
}[] = [
  {
    path: '/fun',
    name: 'Turbos.Fun',
    key: 'fun',
  },
  {
    path: '/launch',
    name: 'Create Token',
    key: 'launch',
  },
  // {
  //   path: '/Ranking',
  //   name: 'Ranking',
  //   key: 'ranking',
  // },
  {
    path: '/gainers',
    name: 'Top Gainers',
    key: 'topGainers',
  },
  {
    path: '/leaderboard',
    name: 'Leaderboard',
    key: 'leaderboard',
  },
];

export const getHeaderMenuIcon = parseGlobIcon(
  import.meta.glob('../assets/images/menus/*', {
    eager: true,
    import: 'default',
  }),
);
